var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_7381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_651_7381",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47716 15.5228 0 10 0C4.47716 0 0 4.47716 0 10C0 15.5228 4.47716 20 10 20Z",
    fill: "#231D9A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_651_7381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0V20H20V0Z",
    fill: "#231D9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 8.4375V-0.3125H7.5V6.40625L0.78125 1.875L-1.25 4.53125L3.28125 7.5H-0.78125V8.4375H8.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 11.5625V20.3125H7.5V13.5938L0.78125 18.125L-1.25 15.4688L3.28125 12.5H-0.78125V11.5625H8.4375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 8.4375V-0.3125H12.5V6.40625L19.2188 1.875L21.25 4.53125L16.7188 7.5H20.7812V8.4375H11.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 11.5625V20.3125H12.5V13.5938L19.2188 18.125L21.25 15.4688L16.7188 12.5H20.7812V11.5625H11.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V7.34375L0.9375 2.96875L-0.15625 4.21875L4.6875 7.5H7.5Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.5V12.6562L0.9375 17.0312L-0.15625 15.7812L4.6875 12.5H7.5Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5V7.34375L19.0625 2.96875L20.1562 4.21875L15.3125 7.5H12.5Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.5V12.6562L19.0625 17.0312L20.1562 15.7812L15.3125 12.5H12.5Z",
    fill: "#F0263C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5625 8.4375V-0.625H8.4375V8.4375H-0.625V11.5625H8.4375V20.625H11.5625V11.5625H20.625V8.4375H11.5625Z",
    fill: "#F0263C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_7381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUk);
export default __webpack_public_path__ + "static/media/UK.019bf6c6abd76057a5d841ad90a68fd9.svg";
export { ForwardRef as ReactComponent };